<template functional>
  <div class="button-ctn">
    <a class="btn" :href="`../${props.pdfFileName}`" target="_blank">
      <font-awesome-icon class="btn__icon" icon="file-pdf" />
      <span>Download em PDF</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'DownloadButton',
  props: {
    pdfFileName: String
  }
}
</script>

<style scoped lang="sass">
@tailwind utilities

.button-ctn
  @apply flex justify-center mt-6

.btn
  @apply text-lg text-white no-underline bg-pink rounded-lg shadow-lg px-2 py-2
  &__icon
    @apply mr-2
</style>
